import React, { createContext, Dispatch, JSX, ReactNode, SetStateAction, useContext, useState } from 'react';
import { logger } from '../util/Logger';

interface Props {
  children: React.ReactNode;
}

interface TriggerIcon {
  open: ReactNode;
  closed: ReactNode;
}

type SidebarLeftContextType = {
  secondaryPane: ReactNode | undefined;
  setSecondaryPane: Dispatch<SetStateAction<ReactNode | undefined>>;
  resizeable: boolean;
  setResizeable: Dispatch<SetStateAction<boolean>>;
  isMobilePaneOpen: boolean;
  setIsMobilePaneOpen: Dispatch<SetStateAction<boolean>>;
  mobileTriggerIcon: TriggerIcon | undefined;
  setMobileTriggerIcon: Dispatch<SetStateAction<TriggerIcon | undefined>>;
};

const SidebarLeftContext = createContext<SidebarLeftContextType>({
  secondaryPane: undefined,
  setSecondaryPane: () => logger.warn('no SidebarLeft provider'),
  resizeable: false,
  setResizeable: () => logger.warn('no SidebarLeft provider'),
  isMobilePaneOpen: false,
  setIsMobilePaneOpen: () => logger.warn('no SidebarLeft provider'),
  mobileTriggerIcon: undefined,
  setMobileTriggerIcon: () => logger.warn('no SidebarLeft provider'),
});

export function useSidebarLeftContext(): SidebarLeftContextType {
  return useContext(SidebarLeftContext);
}

export function SidebarLeftProvider({ children }: Props): JSX.Element {
  const [secondaryPane, setSecondaryPane] = useState<React.ReactNode>();
  const [resizeable, setResizeable] = useState<boolean>(false);
  const [isMobilePaneOpen, setIsMobilePaneOpen] = useState<boolean>(false);
  const [mobileTriggerIcon, setMobileTriggerIcon] = useState<SidebarLeftContextType['mobileTriggerIcon']>(undefined);

  return (
    <SidebarLeftContext.Provider
      value={{
        secondaryPane,
        setSecondaryPane,
        resizeable,
        setResizeable,
        isMobilePaneOpen,
        setIsMobilePaneOpen,
        mobileTriggerIcon,
        setMobileTriggerIcon,
      }}
    >
      {children}
    </SidebarLeftContext.Provider>
  );
}
